<template>
<div class="heading text-center" style="padding:20px">
    <div class="heading text-center">
        <div class="vld-parent">
            <loading :active.sync="isLoading" loader= 'bars' 
            :can-cancel="true" 
            :on-cancel="onCancel"
            :is-full-page="fullPage"></loading>
        </div>
        <img class="dividerline" src="../assets/img/sep.png" alt="">
        <h2>Our Premium Sponsors</h2>
    
        <img class="dividerline" src="../assets/img/sep.png" alt="">
            <h3>Our Supporters and Partners</h3>
    </div>

    <div class="row" style="align-content:center">
        <div style="text-align:left" v-for="(data, i) in sponsorlist" :key="i">
            <div class="restmenuwrap" style="height:300px;">
                <h3 class="maincat notopmarg text-center"><span v-html="data.sponsorname"/></h3>
                <div style="padding:10px" v-html="data.imagelink"/> &nbsp;
            </div> <br/>
        </div>
    </div>
</div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from 'axios';
  export default {
    name: 'Sponsor',
     components: {
      Loading
    },
    data () {
      return {
        msg: 'Sponsor',
        isLoading: false,
        fullPage: true,
        info: null,
        sponsorlist: null,
        test:'../../assets/img/sponsor/euroashfords.png'
    }
  },
  methods: {
    onCancel() {
              console.log('User cancelled the loader.')
            }
    },
    mounted () {
    this.isLoading = true;
    axios
      .get(process.env.NODE_API + '/sponsors')
      .then(response => {
        this.info = response.data
        this.sponsorlist=this.info[0].sponsorlist        
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => this.isLoading = false)
  }
}

</script>

<style>
 
</style>



// WEBPACK FOOTER //
// src/components/Sponsor.vue